
import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const RedirectToHome = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Tüm search parametrelerini bir string olarak al
    const paramsString = searchParams.toString();

    // Home'a yönlendirme yap ve search parametrelerini ekle
    navigate(`/?${paramsString}`);
  }, [navigate, searchParams]);

  return null; // Bu bileşen ekrana bir şey render etmez
};

export default RedirectToHome;
